import React, { useState, useRef, useCallback } from "react";
import useFetchOpenConcerns from "../lib/getOpenConcerns";
import Spinner from "../../utils/spinner";
import { CiSearch } from "react-icons/ci";
import "./Open_concern.css";

export default function Openconcerns() {
  const [searchTerm, setSearchTerm] = useState("");

  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
  } = useFetchOpenConcerns();

  const observerRef = useRef();
  const lastOpenConcernRef = useCallback(
    (node) => {
      if (isFetchingNextPage) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );

  const filteredConcerns = data?.pages
    .flatMap((page) => page.concerns)
    .filter((concern) =>
      concern?.trackingID?.toLowerCase().includes(searchTerm.toLowerCase())
    );

  return (
    <div className="open-concern">
      <div className="headers">
        <p>Open Concern</p>
        <span>
          <CiSearch style={{ fontSize: "24px" }} />
          <input
            type="text"
            placeholder="Search concern by Tracking Num"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </span>
      </div>

      <div className="customer-concerns">
        {isLoading && <Spinner />}
        {isError && (
          <p style={{ fontFamily: "Montserrat" }}>
            Failed to load open concerns.
          </p>
        )}
        {!isLoading && !isError && (
          <table>
            <thead>
              <tr>
                <th>Ticket Code</th>
                <th>Tracking Number</th>
                <th>Customer Email</th>
                <th>Subject</th>
                <th>Concern</th>
                <th>Status</th>
                <th>Date Submitted</th>
              </tr>
            </thead>
            <tbody>
              {filteredConcerns?.map((concern, i) => {
                const isLast = i === filteredConcerns.length - 1;
                return (
                  <tr
                    key={concern._id}
                    ref={isLast ? lastOpenConcernRef : null}
                  >
                    <td>{concern?.ticketCode}</td>
                    <td>{concern?.trackingID}</td>
                    <td>{concern?.raisedBy?.email}</td>
                    <td>{concern.subject}</td>
                    <td>
                      {concern?.message?.split(" ").slice(0, 4).join(" ")}...
                    </td>
                    <td>{concern.status}</td>
                    <td>{new Date(concern.createdAt).toLocaleDateString()}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {isFetchingNextPage && <Spinner />}
    </div>
  );
}
